import * as React from 'react';

export function useOnMount(onMount: () => void) {
    return React.useEffect(() => {
        if (onMount) {
            onMount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useOnUnMount(onUnMount: () => void) {
    return React.useEffect(() => {
        return () => onUnMount && onUnMount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
